import { ActionContext } from 'vuex';

import { TBaseFilterPayload } from '@/common/types/filter';
import { getLocalState } from '@/common/utils/store';

import { TRegionAggregatedFilter } from '../../types/region-aggregated';
import { REGION_AGGREGATED_ACTIONS_NAME } from './name';
import { TRegionAggregatedState } from './types';

import { TPaginationParams } from '@/types/meta';
import links from '@/utils/links';
import request from '@/utils/request';

export async function searchRegionAggregated(
  context: ActionContext<TRegionAggregatedState, unknown>,
  payload: TBaseFilterPayload<TPaginationParams<TRegionAggregatedFilter>>,
) {
  return request(
    context,
    {
      url: links.ved.regionAggregated.getRegionAggregated,
      name: getLocalState(REGION_AGGREGATED_ACTIONS_NAME.searchRegionAggregated),
      abortController: payload.abortController,
      method: 'post',
    },
    payload.params,
  );
}
